<template>
  <div id="app" class="wrapper">
    <Header :headerClass="loginClass" />
    <div id="router">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <Footer :footerClass="loginClass" />
  </div>
</template>

<script>
import store from "@/store";

export default {
  mounted() {},
  computed: {
    loginClass() {
      return store.state.GoogleInfo != null ? "googleSigned" : "notsigned";
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>